<template>
  <div class="edition-panel">
    <form class="controls my-3">
      <div class="row align-items-end">
        <slot/>
        <b-form-checkbox v-model="zoom" class="zoom col" button-variant="outline-primary" button>
          <i class="fa fa-search-plus"></i>
        </b-form-checkbox>
        <div class="col text-center">
          Versos de {{page.start_verse}} a {{page.end_verse}}.
          <b-pagination v-model="pageNumber" :total-rows="lastPage.number" :per-page="1" first-number last-number class="col"/>
        </div>
        <div class="ml-auto mt-3">
          <button class="btn btn-primary" @click.prevent="align(side)">
            Alinear
          </button>
        </div>
      </div>
    </form>
    <div class="display">
      <zoom-on-hover :img-normal="imagePath" :scale="3" :disabled="!zoom"></zoom-on-hover>
      <div class="text-muted mt-1 font-italic">{{edition.reference}}</div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    props: {
      side: {type: String, required: true}
    },
    data() {
      return {zoom: false}
    },
    computed: {
      ...mapState({document: s => s.document}),
      editionName() {
        return this.$store.state[this.side].editionName
      },
      pageNumber: {
        get() {
          return this.$store.state[this.side].pageNumber
        },
        set(pageNumber) {
          return this.setPage({side: this.side, pageNumber})
        }
      },
      edition() {
        return this.document.editions.find(e => e.name === this.editionName)
      },
      page() {
        return this.edition.pages.find(e => e.number === this.pageNumber)
      },
      lastPage() {
        return this.edition.pages[this.edition.pages.length - 1]
      },
      imagePath() {
        return `./editions/${this.document.code}/${this.edition.identifier}/p${this.page.number}.jpg`
      }
    },
    methods: {
      ...mapMutations(['setPage', 'align'])
    }
  }
</script>
<style lang="scss" scoped>
  .controls {
    position: sticky;
    top: 0;
    padding: 0.5rem;
    z-index: 1;
    background-color: white;

    .zoom {
      flex-grow: 0;
    }

    .pagination {
      margin-bottom: 0;
    }
  }

  .display {
    .transcription {
      position: absolute;
      width: 100%;
    }
  }
</style>
